// renderers/componentRenderers/Glossary/styles.ts
import styled from "styled-components";

export const Root = styled.div`
  width: 100%;
`;

export const Container = styled.div`
  width: 100%;
  font-family: var(--body-font);
  color: var(--text-color);

  .glossary-list {
    margin: 0;
  }
`;

export const GlossaryTerm = styled.dt`
  margin-top: 25px;
  font-weight: bold;

  &:first-child {
    margin-top: 0;
  }

  p {
    margin: 0;
  }
`;

export const GlossaryDefinition = styled.dd`
  margin: revert;
  p {
    margin: 0;
  }
`;
